var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8296 0C27.231 0 34.8525 6.93959 34.8525 15.5C34.8525 24.0604 27.231 31 17.8296 31C8.42806 31 0.806641 24.0604 0.806641 15.5C0.806641 6.93959 8.42806 0 17.8296 0ZM17.8296 1.9375C9.60324 1.9375 2.9345 8.00964 2.9345 15.5C2.9345 22.9904 9.60324 29.0625 17.8296 29.0625C26.0559 29.0625 32.7246 22.9904 32.7246 15.5C32.7246 8.00964 26.0559 1.9375 17.8296 1.9375ZM24.9758 10.94C25.3451 11.2763 25.3862 11.7983 25.0989 12.1758L24.9758 12.31L16.454 20.0694C16.0847 20.4057 15.5114 20.4431 15.0967 20.1815L14.9494 20.0694L10.6936 16.1944C10.2782 15.8161 10.2782 15.2027 10.6936 14.8244C11.063 14.4881 11.6363 14.4508 12.0509 14.7123L12.1983 14.8244L15.7017 18.0149L23.4712 10.94C23.8867 10.5617 24.5603 10.5617 24.9758 10.94Z",
    fill: "#24B956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check-circle-outline.b6400256.svg";
export { ForwardRef as ReactComponent };